<template>
  <div class="content">
    <el-form :rules="rules" ref="form" :model="form" label-width="80px">
      <el-row>
        <el-col :span="9">
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="form.name" class="inp1" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="电话：" prop="phone">
            <el-input
              v-model.number="form.phone"
              size="small"
              class="inp1"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="标题：" v-if="index == 2" prop="title">
        <el-input v-model="form.title" size="small" class="inp2"></el-input>
      </el-form-item>
      <el-col :span="8">
        <el-form-item label="内容：" prop="content">
          <el-input
            type="textarea"
            :rows="10"
            v-model="form.content"
            class="inp2"
          ></el-input>
        </el-form-item>
      </el-col>
      <div class="text">(字数应控制在200字以内)</div>
      <div class="button">
        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')" size="small"
            >提交</el-button
          >
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import lib from '../api';
export default {
  props: {
    index: Number
  },
  data() {
    // 验证手机
    let checkPhone = (rule, value, callback) => {
      let reg = /^1[345789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error('请输入11位手机号'));
      } else {
        callback();
      }
    };

    return {
      form: {
        name: '', //姓名
        phone: '', //电话
        content: '', //内容
        title: ''
      },
      title: '',
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          {
            type: 'number',
            validator: checkPhone,
            message: '请输入11位有效手机号号码',
            trigger: 'blur'
          }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '(字数应控制在200字以内)', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      }
    };
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.index == 1) {
            console.log(this.form);
            lib
              .MessageBoard({
                userName: this.form.name,
                phone: this.form.phone.toString(),
                content: this.form.content
              })
              .then(r => {
                console.log(r);
                if (r.code == 2000) {
                  this.$message({
                    message: r.msg,
                    type: 'success'
                  });
                  // this.form.name = '';
                  // this.form.phone = '';
                  // this.form.title = '';
                  // this.form.content = '';
                }
              });
          } else if (this.index == 2) {
            // this.form.title = this.title;
            this.form.phone = this.form.phone.toString();
            console.log(this.form);
            lib.SolicitationOpinions(this.form).then(r => {
              console.log(r);
              if (r.code == 2000) {
                this.$message({
                  message: r.msg,
                  type: 'success'
                });
                // this.form.name = '';
                // this.form.phone = '';
                // this.form.title = '';
                // this.form.content = '';
              }
            });
          }
        } else {
          this.$message.error('提交失败');
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.title {
  width: 100%;
}
.button {
  margin-left: 505px;
}
.text {
  width: 300px;
  height: 40px;
  /* background-color: yellowgreen; */
  font-size: 14px;
  color: #5f6266;
  margin-top: 230px;
  margin-left: 80px;
}
.inp1 {
  width: 280px;
}
.inp2 {
  width: 1010px;
}
.content {
  width: 1100px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Board.vue